export default "__VITE_ASSET__DCS3trtF__"